import { render, staticRenderFns } from "./Damnntipsviewtemplate.vue?vue&type=template&id=4a031aaa&scoped=true&"
import script from "./Damnntipsviewtemplate.vue?vue&type=script&lang=js&"
export * from "./Damnntipsviewtemplate.vue?vue&type=script&lang=js&"
import style0 from "./Damnntipsviewtemplate.vue?vue&type=style&index=0&id=4a031aaa&scoped=true&lang=css&"
import style1 from "./Damnntipsviewtemplate.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a031aaa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
